module.exports = __webpack_public_path__ + "static/media/logo-en.bab55432.png";